import {
  EuiLoadingChart,
  EuiPanel,
  EuiSpacer,
  EuiTitle,
} from "@inscopix/ideas-eui";
import { useQuery } from "@tanstack/react-query";
import { CallOutError } from "components/CallOutError/CallOutError";
import { queryKeys } from "django/queryKeys";
import { getMarketingConsent } from "django/marketingConsentDjango";
import { CheckboxMarketingConsent } from "./CheckboxMarketingConsent";

export const PanelMarketingPreference = () => {
  const { isInitialLoading, data: initialMarketingConsent } = useQuery({
    queryKey: queryKeys.marketingConsent,
    queryFn: getMarketingConsent,
  });

  return (
    <EuiPanel>
      <EuiTitle size="s">
        <h3>Communication</h3>
      </EuiTitle>
      <EuiSpacer />
      {(() => {
        if (isInitialLoading) {
          return <EuiLoadingChart />;
        } else {
          if (initialMarketingConsent === undefined) {
            return <CallOutError />;
          }
          return (
            <CheckboxMarketingConsent
              initialMarketingConsent={initialMarketingConsent}
            />
          );
        }
      })()}
    </EuiPanel>
  );
};
